import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { format, formatISO, isAfter, isBefore, parseISO } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { DatePickerContainerStyled, DatePickerDisplayStyled, DatePickerStyled, } from './date-picker.styles';
import { Calendar } from './icons';
import { InputValidationMessage } from './input-validation-message';
const dateToString = (date) => formatISO(date, { representation: 'date' });
export const DatePicker = React.forwardRef(({ isDisabled = false, isReadOnly = false, isRequired = false, name, formHooks, validation = {}, minDate, maxDate, placeholder = 'No date selected', displayDateFormat = 'dd MMM yyyy', errorDateFormat = 'd MMMM yyyy', ...rest }, ref) => {
    const [selectedDate, setSelectedDate] = useState(rest.value || (formHooks && formHooks.getValues(name)));
    const [localError, setLocalError] = useState(null);
    const minDateErrorMessage = minDate &&
        `The earliest date you can select is ${format(minDate, errorDateFormat)}`;
    const maxDateErrorMessage = maxDate &&
        `The latest date you can select is ${format(maxDate, errorDateFormat)}`;
    const isBeforeMinDate = (date) => minDate && isBefore(date, minDate.setHours(0, 0, 0, 0));
    const isAfterMaxDate = (date) => maxDate && isAfter(date, maxDate.setHours(0, 0, 0, 0));
    const minMaxValidation = (dateString) => {
        const date = parseISO(dateString);
        if (isBeforeMinDate(date)) {
            return minDateErrorMessage;
        }
        if (isAfterMaxDate(date)) {
            return maxDateErrorMessage;
        }
        return true;
    };
    validation.validate = minMaxValidation;
    const { onChange = () => null, ...registerProps } = (formHooks && formHooks.register(name, validation)) || {};
    const status = rest.status ||
        ((formHooks && formHooks.formState.errors[name]) || localError
            ? 'error'
            : 'default');
    const errors = (formHooks && formHooks.formState.errors[name]) || localError;
    const formattedDisplayDate = (date) => format(date, displayDateFormat);
    const formattedSelectedDate = selectedDate
        ? formattedDisplayDate(new Date(selectedDate))
        : placeholder;
    const placeholderActive = formattedSelectedDate === placeholder;
    const handleChange = (dateString) => {
        setLocalError(null);
        const date = parseISO(dateString);
        setSelectedDate(dateString);
        if (isBeforeMinDate(date)) {
            return setLocalError({
                message: minDateErrorMessage,
            });
        }
        if (isAfterMaxDate(date)) {
            return setLocalError({
                message: maxDateErrorMessage,
            });
        }
    };
    const watch = formHooks ? formHooks.watch : false;
    useEffect(() => {
        if (watch) {
            const subscription = formHooks.watch((value) => {
                if (!value[name]) {
                    handleChange('');
                }
            });
            return () => subscription.unsubscribe();
        }
    }, [watch]);
    return (_jsxs(DatePickerContainerStyled, { children: [_jsx(DatePickerStyled, { type: "date", disabled: isDisabled, readOnly: isReadOnly, required: isRequired, id: name, max: maxDate && dateToString(maxDate), min: minDate && dateToString(minDate), name: name, onChange: (e) => {
                    handleChange(e.target.value);
                    onChange(e);
                }, pattern: "\\d{4}-\\d{2}-\\d{2}", ref: ref, ...rest, ...registerProps, status: status }), _jsxs(DatePickerDisplayStyled, { isDisabled: isDisabled, isReadOnly: isReadOnly, placeholderActive: placeholderActive, status: status, type: "datepicker", children: [formattedSelectedDate, _jsx(Calendar, {})] }), errors && (_jsx(InputValidationMessage, { status: "error", children: errors.message }))] }));
});
//# sourceMappingURL=date-picker.js.map